export function mergePreprocessedItems(items, changes) {
  const byId = new Map(changes.map((item) => [String(item.itemId), item]));
  const merged = items.map((item) => {
    const change = byId.get(String(item.itemId));
    return change ? { ...item, ...change } : item;
  });
  const existing = new Set(items.map(item => String(item.itemId)));
  for (const change of changes) {
    if (!existing.has(String(change.itemId)) && change.createdItem) {
      merged.push(change.createdItem);
      existing.add(String(change.itemId));
    }
  }
  return merged;
}

export function preprocessingChangesGeometry(items, changes) {
  const byId = new Map(items.map((item) => [String(item.itemId), item]));
  return changes.some((change) => {
    const old = byId.get(String(change.itemId));
    return !old || old.size !== change.size || Number(old.qty) !== Number(change.qty)
      || old.kant !== change.kant;
  });
}
